import { useState, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import config from "../../../config";
import { AuthContext } from "../../../contexts/AuthContext";
import { ReactComponent as EmailIcon } from "../../../icons/email-settings.svg";
import { ReactComponent as PasswordIcon } from "../../../icons/password.svg";
import { ReactComponent as ViewIcon } from "../../../icons/view.svg";
import { ReactComponent as NotViewIcon } from "../../../icons/not-view.svg";
import "./login.css"

function Login () {
  const { login } = useContext(AuthContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [viewPassword, setViewPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const onLoginClick = async (username, password) => {
    try {
      const response = await fetch(
        `${config.servicesHosts.authenticationService}/connect/token`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams({
            grant_type: "password",
            username,
            password,
            client_id: "spa",
            scope: "openid profile email api offline_access",
          }),
        }
      );

      if (!response.ok) {
        if (response.status === 503) {
          window.location.href = "/error";
          return;
        }

        try {
          const result = await response.json();
          setErrorMessage(result.error_description || "Login failed");
        } catch {
          setErrorMessage("Login failed");
        }
        return;
      }

      const data = await response.json();
      localStorage.setItem("refresh_token", data.refresh_token);
      login(data.access_token);
      navigate("/");
    } catch (error) {
      console.log("Error fetching login: ", error);
      setErrorMessage("Login failed");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault(); 
    onLoginClick(username, password);
  };

  return (
    <div className="login">
      <div className="container">
        <div className="card">
          <div className="text">Login</div>
        </div>

        <form className="inputs" onSubmit={handleSubmit}>
          <div className="input">
            <EmailIcon />
            <input type="text" placeholder="Email" value={username} 
                   onChange={(e) => setUsername(e.target.value)} required/>
          </div>

          <div className="input">
            <PasswordIcon />
            <input className="pas" type={viewPassword ? "text" : "password"} placeholder="Password"
                   value={password} onChange={(e) => setPassword(e.target.value)} required/>
            <span onClick={() => setViewPassword(!viewPassword)}>
              {viewPassword ? <ViewIcon /> : <NotViewIcon />}
            </span>
          </div>

          <div className="forgot-password">
            Lost Password? <Link to="/forgotPassword">Click Here!</Link>
          </div>

          {errorMessage && (
            <div className="error input">
              <span style={{ paddingLeft: "10px" }}>{errorMessage}</span>
            </div>
          )}

          <div className="submit-container">
            <Link className="cancel" to="https://sentryti.com">
              Cancel
            </Link>
            
            <button className="submit" type="submit">
              Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;